import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    listing: {},
    inquiries: [],
    phoneCallsByGuid: {},
    pager: {},
    excelFilename: '',
});

const leadsForListing = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.LEAD_FOR_LISTING_SUCCESS: {
            const { appendToInquiries, leadsForListingModel } = payload;
            let { inquiries } = leadsForListingModel;
            // If current listing in leadsForListing is the same as one fetched
            // Add them
            if (
                state.listing.listingId &&
                state.listing.listingId === leadsForListingModel.listing.listingId &&
                appendToInquiries
            ) {
                inquiries = appendToInquiries ? [...state.inquiries, ...inquiries] : [...inquiries];
            }

            return assign({}, state, leadsForListingModel, { inquiries });
        }

        case DispatchConstants.LEAD_FOR_LISTING_FAIL:
            return assign({}, state, payload);

        default:
            return state;
    }
};

export default leadsForListing;
